
import Header from "@/components/Header";
import NavBar from "@/components/NavBar";
import ProfileView from "@/components/ProfileView";
import { AuthLoadingScreen } from "@/context/AuthContext";
import { useHomeUser } from "@/hooks/useHomeUser";

const Profile = () => {
  const { currentUser, isLoadingUser } = useHomeUser();

  if (isLoadingUser) {
    return <AuthLoadingScreen />;
  }

  if (!currentUser) {
    return (
      <div className="min-h-screen pb-16 flex items-center justify-center">
        <div className="text-center">
          <h2 className="text-xl font-semibold mb-2">Not Signed In</h2>
          <p className="text-gray-600">Please sign in to view your profile</p>
        </div>
        <NavBar />
      </div>
    );
  }

  return (
    <div className="min-h-screen pb-16">
      <Header title="Your Profile" />
      <ProfileView user={currentUser} homeCourseId={currentUser.homeCourseId} />
      <NavBar />
    </div>
  );
};

export default Profile;
